module.exports = __webpack_public_path__ + "static/img/product_banner_20_zh.06baf51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_20_zh.png
// module id = NaTG
// module chunks = 34